import { render, staticRenderFns } from "./MoneyShop.vue?vue&type=template&id=4588c830&scoped=true&"
import script from "./MoneyShop.vue?vue&type=script&lang=js&"
export * from "./MoneyShop.vue?vue&type=script&lang=js&"
import style0 from "./MoneyShop.vue?vue&type=style&index=0&id=4588c830&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4588c830",
  null
  
)

export default component.exports